export const SECURE_TOKEN = 'dm-v1:secureToken';
export const LOGGED_IN_WITH_TOKEN = 'loggedInWithToken';
